import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const ScreenDetailHolder = styled.div`
  width: 100%;

  .ant-btn-primary,
  .ant-btn-primary:active {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
  }
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: ${Colors.backgroundPrimary};
    border-color: ${Colors.backgroundPrimary};
  }

  .screenDetail__topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .screenDetail__breadcrumb {
    font-size: 14px;
    color: ${Colors.grayMedium};
  }

  .screenDetail__crumb-link {
    color: ${Colors.grayMedium};
    cursor: pointer;
  }

  .screenDetail__crumb-link:hover {
    color: ${Colors.primaryAccent};
  }

  .screenDetail__crumb-current {
    color: ${Colors.textStrong};
    font-weight: 600;
  }

  .screenDetail__buy {
    border-radius: 8px;
  }

  .screenDetail__panel {
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 8px;
    padding: 24px;
  }

  .screenDetail__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }

  .screenDetail__title {
    font-size: 28px;
    font-weight: 700;
    color: ${Colors.coal};
    margin: 0;
  }

  .screenDetail__location {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    text-align: right;
  }

  .screenDetail__location-icon {
    color: ${Colors.primaryAccent};
    font-size: 18px;
    margin-top: 2px;
  }

  .screenDetail__location-main {
    font-size: 14px;
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  .screenDetail__location-sub {
    font-size: 12px;
    color: ${Colors.grayMedium};
  }

  .screenGallery {
    position: relative;
    margin-bottom: 8px;
  }

  .screenGallery__img {
    width: 100%;
    height: 420px;
    object-fit: contain;
    background: ${Colors.background};
    border-radius: 10px;
    display: block;
  }

  .screenGallery .slick-prev,
  .screenGallery .slick-next {
    z-index: 2;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }

  .screenGallery .slick-prev {
    left: 16px;
  }

  .screenGallery .slick-next {
    right: 16px;
  }

  .screenGallery .slick-prev:before,
  .screenGallery .slick-next:before {
    color: ${Colors.textSecondary};
    font-size: 20px;
  }

  .screenDetail__section {
    margin-top: 24px;
  }

  .screenDetail__section-title {
    font-size: 14px;
    font-weight: 700;
    color: ${Colors.textStrong};
    margin: 0 0 10px;
  }

  .screenDetail__description {
    font-size: 14px;
    color: ${Colors.textSecondary};
    line-height: 1.6;
    margin: 0;
    white-space: pre-line;
  }

  .screenDetails {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 14px;
    align-items: stretch;
  }

  .screenDetails__info {
    grid-column: span 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }

  .screenDetails__side {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .screenInfo__item {
    border: 1px solid ${Colors.border};
    border-radius: 12px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-height: 96px;
  }

  .screenInfo__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 24px;
    margin-bottom: 12px;
  }

  .screenInfo__icon {
    color: ${Colors.primaryAccent};
    font-size: 20px;
  }

  .screenInfo__info {
    color: #b0c4de;
    font-size: 16px;
    cursor: pointer;
  }

  .screenInfo__label {
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.textStrong};
  }

  .screenInfo__value {
    font-size: 14px;
    color: ${Colors.textSecondary};
  }

  .statCard {
    flex: 1;
    border: 1px solid ${Colors.border};
    border-radius: 10px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 130px;
  }

  .statCard__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .statCard__icon {
    color: ${Colors.primaryAccent};
    font-size: 20px;
  }

  .statCard__tabs {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .statCard__tab {
    border: 1px solid transparent;
    background: none;
    color: ${Colors.textMuted};
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 6px;
    cursor: pointer;
  }

  .statCard__tab--active {
    color: ${Colors.primaryAccent};
    border-color: ${Colors.primaryAccent};
    background: ${Colors.snow};
    font-weight: 600;
  }

  .statCard__bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
  }

  .statCard__label {
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.textStrong};
  }

  .statCard__value {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  @media only screen and (max-width: 900px) {
    .screenDetails {
      grid-template-columns: 1fr;
    }
    .screenDetails__info {
      grid-column: span 1;
    }
  }

  .screenDetail__section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0 0 12px;
  }

  .screenDetail__section-head .screenDetail__section-title {
    margin: 0;
  }

  .screenDetail__toggle {
    border: none;
    background: none;
    color: ${Colors.textSecondary};
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
  }

  .screenDetail__toggle:hover {
    color: ${Colors.primaryAccent};
  }

  .screenMap {
    position: relative;
  }

  .screenMap__address {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 2;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: ${Colors.snow};
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
    padding: 12px 14px;
    max-width: 280px;
  }

  .screenMap__address-icon {
    color: ${Colors.primaryAccent};
    font-size: 18px;
    margin-top: 2px;
  }

  .screenMap__address-main {
    font-size: 14px;
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  .screenMap__address-sub {
    font-size: 12px;
    color: ${Colors.grayMedium};
  }

  .screenDetail__section .ant-tabs-bar {
    border-bottom: 1px solid ${Colors.border};
  }

  .screenDetail__section .ant-tabs-tab:hover,
  .screenDetail__section .ant-tabs-tab-active {
    color: ${Colors.primaryAccent};
  }

  .screenDetail__section .ant-tabs-ink-bar {
    background-color: ${Colors.primary};
  }

  .audienceNote {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: ${Colors.textMuted};
    font-size: 13px;
    margin: 16px 0;
    text-align: center;
  }

  .audienceNote__icon {
    color: ${Colors.textMuted};
    font-size: 15px;
  }

  .audienceChart__title {
    font-size: 13px;
    color: ${Colors.textSecondary};
    margin-bottom: 8px;
  }

  .audienceChart__canvas {
    height: 360px;
  }

  .audienceEmpty {
    padding: 48px;
    text-align: center;
    color: ${Colors.textMuted};
    font-size: 14px;
  }

  .audienceQualitative__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 4px;
    border-bottom: 1px solid ${Colors.border};
    font-size: 14px;
  }

  .audienceQualitative__label {
    color: ${Colors.textSecondary};
  }

  .audienceQualitative__value {
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  .cameras {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: start;
  }

  .cameras__col {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .cameras__label {
    font-size: 13px;
    font-weight: 600;
    color: ${Colors.textSecondary};
  }

  .cameras__feed {
    width: 100%;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
    background: #1a1a1a;
  }

  .cameras__col:first-child .cameras__feed {
    height: 372px;
  }

  .cameras__feed iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }

  .cameras__feed--empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: ${Colors.textMuted};
    background: ${Colors.gray};
    font-size: 13px;
  }

  .cameras__feed--empty .anticon {
    font-size: 32px;
    color: #cfd3d9;
  }

  .cameras__today {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid ${Colors.border};
    border-radius: 10px;
    padding: 14px 16px;
  }

  .cameras__today-icon {
    color: ${Colors.primaryAccent};
    font-size: 20px;
  }

  .cameras__today-value {
    font-size: 18px;
    font-weight: 700;
    color: ${Colors.textStrong};
  }

  @media only screen and (max-width: 700px) {
    .cameras {
      grid-template-columns: 1fr;
    }
    .cameras__col:first-child .cameras__feed {
      height: 280px;
    }
  }

  .screenDetail__placeholder {
    padding: 48px;
    text-align: center;
    color: ${Colors.grayMedium};
    border: 1px dashed ${Colors.grayMedium};
    border-radius: 8px;
  }
`;

export default ScreenDetailHolder;
